module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Products":"Produkte","Categories":"Kategorien","Attribute sets":"Attribut-Sets","Attributes":"Attribute","Sub-Articles":"Unterartikel"}}')
  delete Component.options._Ctor
}
